<template>
  <div class="row-wrap footer-wrap">
    <div class="row-contents row-footer">
      
      <div class="footer-align">
        <div class="footer-row">

          <router-link tag="div"
            class="link-element"
            :to="{name:'policy'}">
            {{ $t('welcome.policy') }}
          </router-link>

          <router-link tag="div"
            class="link-element"
            :to="{name:'commercial-terms'}">
            {{ $t('welcome.commercial_terms') }}
          </router-link>

          <router-link tag="div"
            class="link-element"
            :to="{name:'privacy'}">
            {{ $t('welcome.privacy') }}
          </router-link>

          <router-link tag="div"
            class="link-element"
            :to="{name:'whats-new'}">
            {{ $t("account_modal.what_s_new_in_bt") }}
          </router-link>

          <router-link tag="div"
            class="link-element"
            :to="{name:'notice'}">
            {{ $t("account_modal.notice") }}
          </router-link>

        </div>

        <div class="footer-row">
          
        </div>

        <div class="footer-row">

        </div>

        <div class="footer-row">
          <span>
            <span>BiblioTrees</span>
            <span class="footer-div-vertical">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>전화: 02-711-0405</span>
            <span class="footer-div-vertical">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>이메일: <a href="mailto:services@bibliotrees.net">services@bibliotrees.net</a></span>
          </span>
        </div>
        
        <div class="footer-row">
          <span>
            <span>주소: 서울특별시 종로구 세종대로23길 47, 6층 603-377호 비블리오트리즈 주식회사</span>
            <span class="footer-div-vertical">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>사업자: (주)비블리오트리즈</span>
            <span class="footer-div-vertical">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>사업자등록번호: 360-87-00941</span>
            <span class="footer-div-vertical">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>대표자: 조유진</span>
          </span>
        </div>

        <div class="footer-row">
          <span>
            <span>입금처: 100-033-372182 (신한은행, 예금주: 비블리오트리즈주식회사)</span>
            <span class="footer-div-vertical">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>서비스 점검시간: GMT+9(한국표준시) 00:00-00:10</span>
          </span>
        </div>

      </div>

      <div class="footer-align">
        <div class="footer-row">
          <div>
            <v-btn icon small target="_blank"
              @click="gaClick('welcome_btn_twitter')"
              href="https://twitter.com/BiblioTrees">
              <v-icon small>mdi-twitter</v-icon>
            </v-btn>
          </div>
          <div>
            <v-btn icon small target="_blank"
              @click="gaClick('welcome_btn_facebook')"
              href="https://www.facebook.com/bibliotrees/">
              <v-icon small>mdi-facebook</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- TODO: language -->
      
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    },
  }
}
</script>

<style scoped>

  .row-wrap {
    width: 100%;
  }

  .row-contents {
    width: 100%;
    max-width: 1280px;
    margin: auto;
    display: flex;
  }

  .footer-wrap {
    background-color: #FAFAFA;
  }

  .row-footer {
    height: 180px;
    justify-content: space-between;
    padding: 30px 20px 30px;
  }

  .footer-row {
    display: flex;
    flex-direction: row;
  }

  .footer-row > div {
    margin-right: 12px;
    margin-bottom: 24px;
  }

  .footer-row > span {
    /* margin-right: 12px; */
    margin-bottom: 8px;
  }

  .footer-row a {
    color: #142142;
  }

  .footer-div-vertical {
    color: gainsboro;
  }

  @media (max-width: 1080px) {
    .row-footer {
      height: 100%;
    }

    .footer-row {
      flex-direction: column;
      margin-bottom: 12px;
    }
  }

  @media only screen and (max-width: 550px) {
    .footer-wrap {
      min-width: 327px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared_components/part/FooterWelcome.vue